import * as preact from "preact";
import { $$, DateFormat } from "../../Core/Common";
import { AutoComplete } from "../../Common/AutoComplete/AutoComplete";
import { BaseComponent, IBaseComponentProps } from "../../Common/BaseComponent/BaseComponent";
import { Select } from "../../Common/Select/Select";
import { TextBox } from "../../Common/TextBox/TextBox";
import { CitationList } from "../CitationList/CitationList";
import { TopicEditor } from "../TopicEditor/TopicEditor";

export interface ICitationEditorProps extends IBaseComponentProps
{
    citations?: any[];
    onCitationComplete?: Function;
}

export class CitationEditor extends BaseComponent<ICitationEditorProps>
{
    private _autoAuthor: AutoComplete;
    private _citationId: string;
    private _citationList: CitationList;
    private _isEdit: boolean;
    private _lstType: Select;
    private _lstSource: Select;
    private _pnlCurrentCitations: HTMLElement;
    private _pnlHeader: HTMLElement;
    private _txtContainerTitle: TextBox;
    private _txtDate: TextBox;
    private _txtIssue: TextBox;
    private _txtNotes: TextBox;
    private _txtPageNumber: TextBox;
    private _txtParagraph: TextBox;
    private _txtTitle: TextBox;
    private _txtUrl: TextBox;
    private _txtVolume: TextBox;

    public constructor(props: ICitationEditorProps)
    {
        super(props);
    }

    public setData(index, citations?, isEdit?)
    {
		this._isEdit = isEdit;
		this._citationList.setData(citations);
		$$.display(this._pnlCurrentCitations, citations && citations.length > 0 && !this._isEdit);

		var data = citations[index]||{};
        this._citationId = data.Id;
        this._lstType.setValue(data.TypeId);
        this._lstSource.setValue(data.SourceId);
        this._txtContainerTitle.setValue(data.ContainerTitle);
        this._txtTitle.setValue(data.Title);
        this._autoAuthor.setValue(data.AuthorId, data.Author);
        this._txtDate.setValue($$.formatDate(data.Date, DateFormat.ShortDate));
        this._txtUrl.setValue(data.URL);
        this._txtPageNumber.setValue(data.PageNumber);
        this._txtParagraph.setValue(data.ParagraphNumber);
        this._txtIssue.setValue(data.Issue);
        this._txtVolume.setValue(data.Volume);
		this._txtNotes.setValue(data.Notes);

		$(this._pnlHeader).text(index != null ? "Edit Citation": "New Citation");
    }

    public getData()
    {
        var data = {} as any;
        data.Id = this._citationId;
        data.TypeId = this._lstType.getValue();
        data.Type = this._lstType.getText();
        data.SourceId = this._lstSource.getValue();
        data.ContainerTitle = this._txtContainerTitle.getValue();
        data.Title = this._txtTitle.getValue();
        data.AuthorId = this._autoAuthor.getValue();
        data.Author = this._autoAuthor.getText();
        data.Date = Date.parse(this._txtDate.getValue()) || null;
        data.URL = this._txtUrl.getValue();
        data.PageNumber = this._txtPageNumber.getValue();
        data.ParagraphNumber = this._txtParagraph.getValue();
        data.Issue = this._txtIssue.getValue();
        data.Volume = this._txtVolume.getValue();
		data.Notes = this._txtNotes.getValue();
        return data;
    }

	public getIsEdit()
	{
		return this._isEdit;
	}

	public focus()
	{
		this._lstSource.focus();
	}

	private _onCitationSelect(number)
    {
		if(this.props.onCitationComplete)
		{
			this.props.onCitationComplete(number);
		}
	}

    public render()
    {
        return (
            <div ref={(ref)=>this.Container= ref}>
				<div ref={(ref)=> this._pnlCurrentCitations = ref}>
					<div className="header">Current Citations</div>
					<div style={{maxHeight: "300px", overflow: "auto"}}>
                        <CitationList ref={(citationList) => this._citationList = citationList} readOnly={true} onSelect={this._onCitationSelect.bind(this)} />
					</div>
					<hr />
				</div>
				
				<div ref={(ref)=> this._pnlHeader = ref} className="header"></div>
                <div>
                    <table>
                        <tr>
                            <th>Type</th>
                            <th>Source</th>
                            <th>Title</th>
                            <th>Container Title</th>
                        </tr>
                        <tr>
                            <td>
                                <Select ref={(ref) => this._lstSource = ref} style={{ width: "100px" }} items=
                                    {
                                        [
                                            { Key: 1, Value: "Primary" },
                                            { Key: 2, Value: "Secondary" },
                                            { Key: 3, Value: "Tertiary" }
                                        ]
                                    }
                                />

                            </td>
                            <td>
                                <Select ref={(ref) => this._lstType = ref} style={{ width: "140px" }} items=
                                    {
                                        [
                                            { Key: 1, Value: "Academic Journal" },
                                            { Key: 2, Value: "Book" },
                                            { Key: 3, Value: "Document" },
                                            { Key: 4, Value: "Letter" },
                                            { Key: 5, Value: "Periodical" },
                                            { Key: 6, Value: "Personal Journal" },
                                            { Key: 7, Value: "Website"}
                                        ]
                                    }
                                />

                            </td >
                            <td>
                                <TextBox ref={(ref) => this._txtTitle = ref} style={{ width: "200px" }} />
                            </td>

                            <td>
                                <TextBox ref={(ref) => this._txtContainerTitle = ref} style={{width: "200px"}} />
                            </td>
                        </tr >
                    </table >
                    <table style={{marginTop:"2px"}}>
                        <tr>
                            <th>Author</th>
                            <th>Date</th>
                            <th>URL</th>
                            <th>Page</th>
                            <th>Paragraph</th>
                            <th>Issue</th>
                            <th>Volume</th>
                        </tr>
                        <tr>
                            <td>
                                <AutoComplete ref={(ref) => this._autoAuthor = ref}
                                    CreateComponent={TopicEditor}
                                    Context="1"
                                    CreateData={{ TopicType: 1 }}
                                    LookupService="api/event/GetTopics"/>
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtDate = ref} style={{width: "70px"}} />
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtUrl = ref} style={{width: "150px"}} />
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtPageNumber = ref} style={{ width: "50px" }} />
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtParagraph = ref} style={{ width: "50px" }} />
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtIssue = ref} style={{ width: "50px" }} />
                            </td>
                            <td>
                                <TextBox ref={(ref) => this._txtVolume = ref} style={{ width: "50px" }} />
                            </td>
                        </tr >
                    </table >
					<div style={{padding: "5px 5px"}}>
					    <label>Notes</label><br/>
                        <TextBox IsMultiLine={true} ref={(ref)=>this._txtNotes = ref} style={{width: "100%"}} />
					</div>
                </div >
            </div >
        );
    }
}

